var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-lg": "" } },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _vm.capabilitiesSet
            ? _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _vm.onGenericTrial
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-0",
                          class: { "theme--light": !_vm.darks.warning },
                          attrs: { type: "warning", dismissible: "" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\tYour trial expires " +
                              _vm._s(_vm.trialDaysRemaining) +
                              ". Any users, departments or features not in the plan you choose will be removed.\n\t\t\t\t"
                          )
                        ]
                      )
                    : !_vm.$store.state.activePlan &&
                      _vm.spark.state.currentTeam
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-0",
                          class: { "theme--light": !_vm.darks.error },
                          attrs: { type: "error" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\tYour trial has expired and you are not subscribed to a plan. Choose a plan to get started.\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-slide-x-reverse-transition",
                    { attrs: { mode: "out-in" } },
                    [
                      _c("router-view", {
                        key: _vm.$route.path,
                        attrs: { user: _vm.user, teams: _vm.teams },
                        on: { reloadData: _vm.loadMetadata }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("core-modals")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: 3000,
            color: _vm.snackbar.state,
            top: true,
            right: true
          },
          model: {
            value: _vm.snack,
            callback: function($$v) {
              _vm.snack = $$v
            },
            expression: "snack"
          }
        },
        [_vm._v("\n\t\t\t" + _vm._s(_vm.snackbar.text) + "\n\t\t")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c5716d4", { render: render, staticRenderFns: staticRenderFns })
  }
}